import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Txt,
  View,
  TenantDepositDetails,
  PaymentFlow,
  Modal,
} from 'components';
import { useState } from 'react';
import { formatCurrency } from 'helpers/formatNumber';
import { useTenancy } from 'state';
import { ModalGlobal } from 'lib/ModalContext';
import styles from './OrdersNotSetup.module.scss';

/**
 * OrdersNotSetup
 *
 * @return {JSX.Element}
 */
const OrdersNotSetup = ({ className, onSuccess }) => {
  const [payOrder, setPayOrder] = useState(false);
  const tenancyDoc = useTenancy();
  const { tenants: tenantsCollection } = tenancyDoc;

  const tenancyData = tenancyDoc.data;
  const tenantsData = tenantsCollection.data;

  const handleSetupStandingOrder = () => {
    setPayOrder(true);
    console.log('Payment rent');
  };

  const handleClose = () => setPayOrder(false);

  return (
    <FlexContainer
      className={classNames(
        styles.OrdersNotSetup,
        className,
        OrdersNotSetup.displayName
      )}
      column
      gap
    >
      <Txt bold>⚠️ Awaiting setup</Txt>
      <View>
        <Txt xxx bold>
          £{formatCurrency(tenancyData.payments.standingOrderAmount)}
        </Txt>
        <Txt caption>/£{formatCurrency(tenancyData.payments.rentAmount)}</Txt>
      </View>
      <FlexContainer column gapHalf>
        {tenantsData.map((t) => {
          return (
            <TenantDepositDetails
              key={t.id}
              fullName={t.data.fullName}
              actionLabel={
                t.data.payments?.standingOrderPlaidUid ? 'PAID' : 'DUE'
              }
              emailAddress={t.data.emailAddress}
              mobileNumber={t.data.mobileNumber}
              isDone={t.data.payments?.standingOrderPlaidUid}
            />
          );
        })}
      </FlexContainer>
      <Txt regular>
        A standing order is an instruction to your bank to make a payment on
        monthly intervals. Propa's partner Plaid allows you to easily create a
        payment without the hassle of typing in bank details, amounts and
        references.
      </Txt>
      <Txt regular>Tap the button below to setup your standing order.</Txt>
      <Button success onClick={handleSetupStandingOrder}>
        Setup a Standing Order
      </Button>
      {payOrder ? (
        <ModalGlobal>
          <Modal
            title="Standing Order Setup"
            onClose={handleClose}
            showCloseButton
          >
            <PaymentFlow paymentType="tenantRent" onSuccess={onSuccess} />
          </Modal>
        </ModalGlobal>
      ) : null}
    </FlexContainer>
  );
};

OrdersNotSetup.displayName = 'OrdersNotSetup';

export default OrdersNotSetup;
